import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Spinner} from '@npck/libs/commons';
import {NgxSkeletonLoaderConfigTheme} from 'ngx-skeleton-loader';
import {
    CellDataType,
    CellViewModel,
    CellViewModelType,
    ClassificationColumn,
    ClassificationRow,
    CurrencyCellViewModel,
} from '../classification-table.component';

@Component({
    selector: 'af-classification-table-cell',
    standalone: false,
    templateUrl: './classification-table-cell.component.html',
    styleUrl: './classification-table-cell.component.scss',
})
export class ClassificationTableCellComponent implements OnChanges, OnInit {
    @Input() column: ClassificationColumn;
    @Input() data: CellViewModelType[];
    @Input() translationPostfix: string;
    @Input() maxDataRows: number;
    @Input() dataType: CellDataType;
    @Input() row: ClassificationRow;
    @Input() currency: string;
    @Output() showMoreClickListener = new EventEmitter<void>();
    Spinner = Spinner;
    labelLayoutType: 'grid' | 'column' | 'flex' = 'grid';
    hasAlert = false;
    viewModelData: CellViewModel[];
    skeletonConfig: NgxSkeletonLoaderConfigTheme;

    ngOnInit(): void {

        const config: NgxSkeletonLoaderConfigTheme = {
            '--ngx-skeleton-loader-light-mode-color': this.column === 'forecastFuture' ? '#FAFAFA' : '#E1F5E7',
            '--ngx-skeleton-loader-light-mode-color-to': this.column === 'forecastFuture' ? '#F0F0F0' : '#F2FAF4',
            height: '100%',
            'border-radius': '16px',
            backgroundColor: this.column === 'forecastFuture' ? '#F0F0F0' : '#F2FAF4',
            border: '1px solid #8FC5A8',
            'margin-bottom': 0,
        };

        if (['forecastFuture', 'forecastPast'].includes(this.column)) {
            delete config.border;
        }
        this.skeletonConfig = config;
    }

    ngOnChanges(_: SimpleChanges): void {
        this.labelLayoutType = this.maxDataRows === 2 ? 'column' : 'grid';
        if (!this.data?.length) {
            this.viewModelData = [];
            this.hasAlert = false;
            return;
        }
        const isCurrencyGroup = this.data.some(item => 'currency' in item);
        if (isCurrencyGroup) {
            const groupedCurrencies = this.data as CurrencyCellViewModel[];
            const match = groupedCurrencies.find(item => item.currency?.code === this.currency);
            this.viewModelData = match?.cells ?? [];
        } else {
            this.viewModelData = this.data as CellViewModel[];
        }
        this.hasAlert = this.viewModelData.some(item => item.hasAlert);
    }
}
